/* hb-rich.js: kleine Helfer fuer sections/hb-rich-content.liquid (Schritte, Code kopieren). Ohne JS bleibt alles lesbar. */
(function () {
  'use strict';

  function initFlow(flow) {
    if (flow.getAttribute('data-hb-init')) { return; }
    flow.setAttribute('data-hb-init', '1');
    var panels = Array.prototype.slice.call(flow.querySelectorAll('[data-hb-panel]'));
    var tabs = Array.prototype.slice.call(flow.querySelectorAll('[data-hb-tab]'));
    var ctl = flow.querySelector('[data-hb-ctl]');
    var note = flow.querySelector('[data-hb-note]');
    var prev = flow.querySelector('[data-hb-prev]');
    var next = flow.querySelector('[data-hb-next]');
    if (!panels.length || panels.length !== tabs.length) { return; }
    var current = 0;

    function show(i, focus) {
      current = Math.max(0, Math.min(panels.length - 1, i));
      panels.forEach(function (p, n) { p.hidden = n !== current; });
      tabs.forEach(function (t, n) {
        var on = n === current;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      if (prev) { prev.disabled = current === 0; }
      if (next) { next.disabled = current === panels.length - 1; }
      if (note) { note.textContent = 'Schritt ' + (current + 1) + ' von ' + panels.length; }
      if (focus) { tabs[current].focus(); }
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(n + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(n - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
        else if (e.key === 'End') { e.preventDefault(); show(panels.length - 1, true); }
      });
    });
    if (prev) { prev.addEventListener('click', function () { show(current - 1, false); }); }
    if (next) { next.addEventListener('click', function () { show(current + 1, false); }); }

    flow.classList.add('is-js');
    if (ctl) { ctl.hidden = false; }
    if (note) { note.hidden = false; }
    show(0, false);
  }

  function initCopy(btn) {
    if (btn.getAttribute('data-hb-init')) { return; }
    btn.setAttribute('data-hb-init', '1');
    var status = btn.parentNode.querySelector('[data-hb-copy-status]');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-hb-copy') || '';
      var done = function (ok) {
        if (status) { status.textContent = ok ? 'Code kopiert' : 'Kopieren nicht möglich'; }
        var old = btn.textContent;
        if (ok) {
          btn.textContent = 'Kopiert';
          window.setTimeout(function () { btn.textContent = old; }, 2000);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
      } else {
        done(false);
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hb-flow]'), initFlow);
    Array.prototype.forEach.call(document.querySelectorAll('[data-hb-copy]'), initCopy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme-Editor: Abschnitt wurde neu geladen
  document.addEventListener('shopify:section:load', init);
})();
